export const routeGuard = 'POST /tracking/couriers/location';
